import { render, staticRenderFns } from "./playerAgeRadar.vue?vue&type=template&id=dd555392&scoped=true"
import script from "./playerAgeRadar.vue?vue&type=script&lang=js"
export * from "./playerAgeRadar.vue?vue&type=script&lang=js"
import style0 from "./playerAgeRadar.vue?vue&type=style&index=0&id=dd555392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd555392",
  null
  
)

export default component.exports